import {
    FetchState,
  } from "@/shared/types";
  import {
    EmailTemplateState,
    EmailTemplate,
    EmailTemplateSendRequest,
    EmailTemplateDetail, EmailTemplateResponse
} from "../types";
  import * as UserService from "@/shared/api/userService";
  import * as storeHelper from "@/shared/storeHelper";
  import { defineStore } from "pinia";
  import _ from "lodash";

  export const initialState: EmailTemplateState = {
    fetchState: FetchState.Uninitialized,
    emailTemplates: null,
    partners: null,
    emailTemplateDetail: null,
    quota: null,
  };
  export const useEmailTemplateStore = defineStore("emailTemplateStore", {
      state: (): EmailTemplateState => (_.cloneDeep(initialState)),
      getters: {
          isLoaded: state => state.fetchState === FetchState.Loaded,
          templates: state => state.emailTemplates,
          partnerDictionary: state => state.partners,
          template: state => state.emailTemplateDetail,
          sendQuotas: state => state.quota,
          canSendTestEmail: state => state.emailTemplateDetail ? state.emailTemplateDetail.canSendTestEmail : false,
          htmlContent: state => state.emailTemplateDetail ? state.emailTemplateDetail.html : null,
          emailSubject: state => state.emailTemplateDetail ? state.emailTemplateDetail.subject : null,
          parameters: state => state.emailTemplateDetail && state.emailTemplateDetail.parameters ? state.emailTemplateDetail.parameters : [],
      },
      actions: {
          setFetchState (fetchState: FetchState) {
              this.fetchState = fetchState;
          },
          setEmailTemplates (response: EmailTemplateResponse) {
            this.emailTemplates = response.emailTemplates;
            this.partners = response.partners;
            this.quota = response.quota;
            this.emailTemplateDetail = null;
          },
          setEmailTemplateDetail (detail: EmailTemplateDetail) {
              this.emailTemplateDetail = detail;
          },
          getAdminEmailTemplates () {
            this.setFetchState(FetchState.Loading);
            return UserService.getAdminEmailTemplates()
                .then(r => {
                    this.setEmailTemplates(r.data);
                    this.setFetchState(FetchState.Loaded);
                })
                .catch(err => storeHelper.handleError({ error: err, rethrow: true, timeout: 5000 }));
          },
          resetEmailTemplate () {
            this.setEmailTemplateDetail(null);
          },
          getAdminEmailTemplateDetail (templateName: string) {
              this.setFetchState(FetchState.Loading);
              return UserService.getAdminEmailTemplateDetail(templateName)
                  .then(r => {
                      this.setEmailTemplateDetail(r.data);
                      this.setFetchState(FetchState.Loaded);
                  })
                  .catch(err => storeHelper.handleError({ error: err, rethrow: true, timeout: 5000 }));
          },
          postAdminEmailTemplateTest (emailTemplateSendRequest: EmailTemplateSendRequest) {
              this.setFetchState(FetchState.Loading);
              return UserService.postAdminEmailTemplateTest(emailTemplateSendRequest)
                  .then(r => {
                      this.setFetchState(FetchState.Loaded);
                  })
                  .catch(err => storeHelper.handleError({ error: err, rethrow: true, timeout: 5000 }));
          },
      }
  });